import { useTranslation } from 'react-i18next';
import { Typography, NewDropdown } from 'app/components/ui';
import { Modal as BootstrapModal } from 'react-bootstrap';
import { useState } from 'react';
import { IconButton } from 'shared/ui/IconButton/IconButton';

import './HighlightedPicker.scss';

interface HighlightedProps {
  currentValue: string;
  onValueChange: (value: string) => void;
}

export const HighlightedPicker = ({ currentValue, onValueChange }: HighlightedProps) => {
  const { t } = useTranslation('tag');

  const [show, setShow] = useState(false);
  const highlightedOptions = [
    {
      label: t('highlighted.option.tagger'),
      value: 'tagger',
    },
    {
      label: t('highlighted.option.status'),
      value: 'status',
    },
    { label: t('highlighted.option.origin'), value: 'origin' },
    { label: t('highlighted.option.process'), value: 'process' },
  ];

  const contextColors = [
    {
      category: t('highlighted.option.status'),
      colors: [
        { label: t('status.invalid'), value: 'invalid' },
        { label: t('status.valid'), value: 'valid' },
        { label: t('status.unvalidated'), value: 'unvalidated' },
      ],
    },
    {
      category: t('highlighted.option.process'),
      colors: [
        { label: t('status.draft'), value: 'draft' },
        { label: t('status.need_attention'), value: 'need_attention' },
        { label: t('status.verified'), value: 'verified' },
        { label: t('status.approved'), value: 'approved' },
      ],
    },
    {
      category: t('highlighted.option.tagger'),
      colors: [
        { label: t('highlighted.ai'), value: 'human' },
        { label: t('highlighted.human'), value: 'ai' },
      ],
    },
    {
      category: t('highlighted.option.origin'),
      colors: [
        { label: t('highlighted.core'), value: 'core' },
        { label: t('highlighted.extension'), value: 'extension' },
      ],
    },
  ];

  return (
    <>
      <NewDropdown
        currentValue={currentValue}
        label={`${t('highlighted.label')}:`}
        options={highlightedOptions}
        onUpdate={onValueChange}
        showSelectBox
        customOption={
          <div onClick={() => setShow(true)} style={{ width: '100%' }}>
            <Typography variant="body-5" fontWeight="bold">
              {t('color.guide.action')}
            </Typography>
          </div>
        }
      />

      <BootstrapModal show={show} onHide={() => setShow(false)} contentClassName="highlighted-modal">
        <BootstrapModal.Header className="highlighted-modal__header">
          <Typography variant="body-8" fontWeight="semibold">
            {t('color.guide.label')}
          </Typography>

          <IconButton variant="transparent" icon="close" onClick={() => setShow(false)} data-bs-dismiss="modal" aria-label="Close" />
        </BootstrapModal.Header>

        <BootstrapModal.Body className="highlighted-modal__body">
          {contextColors.map((context) => (
            <ul key={context.category} className="highlighted-modal__context-section">
              <Typography variant="body-7" fontWeight="semibold" color="#616066">
                {context.category}
              </Typography>

              {context.colors.map((color) => (
                <li key={color.label} className="highlighted-modal__context-item">
                  <div className={`highlighted-modal__context-color highlighted-modal__context-color--${color.value}`} />
                  <Typography variant="body-7" fontWeight="light" color="#616066">
                    {color.label}
                  </Typography>
                </li>
              ))}
            </ul>
          ))}
        </BootstrapModal.Body>
      </BootstrapModal>
    </>
  );
};
